import React from 'react';
import {SafeAreaView, StyleSheet} from 'react-native';
import flexCheck from '../../../../utils/flexCheck';

const SafeAreaViews = React.forwardRef((props, ref) => {
  const styles = StyleSheet.flatten(props.style);
  let updatedStyles = false;
  if (typeof props !== 'undefined' && typeof styles !== 'undefined') {
    updatedStyles = flexCheck(styles);
  }
  return (
    <>
      <SafeAreaView
        ref={ref}
        {...props}
        style={updatedStyles ? updatedStyles : styles}
      />
    </>
  );
});
export default SafeAreaViews;
